// extracted by mini-css-extract-plugin
module.exports = {"textarea":"TextArea_textarea__ecem3","error":"TextArea_error__PGUc9"};